/*
  artesano-accordion-empty.js

  Oculta los acordeones de la ficha de producto que no tienen contenido.

  Por que hace falta: el contenido de esas filas sale ahora de los metacampos
  del producto (custom.caracteristicas / ingredientes / recomendaciones). Si un
  producto no tiene uno de esos metacampos relleno, el tema sigue pintando el
  <details> con su titulo y un cuerpo vacio, y el visitante lo abre para no
  encontrar nada.

  La seccion main-product es un archivo del nucleo de Trade y no se toca, asi
  que el ajuste se hace aqui, en un archivo nuevo que sobrevive a las
  actualizaciones del tema.
*/

(function () {
  'use strict';

  var SELECTOR_ACORDEON = '.product__accordion';
  var SELECTOR_CUERPO = '.accordion__content';

  function tieneContenido(cuerpo) {
    // Texto visible, ignorando espacios en blanco del propio Liquid.
    if (cuerpo.textContent && cuerpo.textContent.trim().length > 0) return true;

    // Un cuerpo puede no tener texto y aun asi ser legitimo: una imagen, un
    // video o un bloque de aplicacion.
    return !!cuerpo.querySelector('img, picture, svg, video, iframe, table');
  }

  function limpiar(raiz) {
    var acordeones = (raiz || document).querySelectorAll(SELECTOR_ACORDEON);

    Array.prototype.forEach.call(acordeones, function (acordeon) {
      if (acordeon.dataset.artesanoRevisado === 'si') return;

      var cuerpo = acordeon.querySelector(SELECTOR_CUERPO);

      // El bloque de productos complementarios reutiliza la clase
      // .product__accordion pero no tiene .accordion__content: su contenido va
      // en .complementary-products__container y ademas se carga por AJAX. Sin
      // esta guarda lo ocultariamos por error.
      if (!cuerpo) return;

      acordeon.dataset.artesanoRevisado = 'si';

      if (!tieneContenido(cuerpo)) {
        acordeon.hidden = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { limpiar(); }, { once: true });
  } else {
    limpiar();
  }

  // La seccion de producto se vuelve a pintar al cambiar de variante y al
  // editar en el personalizador; en ambos casos llegan nodos nuevos.
  if ('MutationObserver' in window) {
    var observador = new MutationObserver(function (mutaciones) {
      for (var i = 0; i < mutaciones.length; i++) {
        if (mutaciones[i].addedNodes && mutaciones[i].addedNodes.length) {
          limpiar();
          return;
        }
      }
    });
    observador.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
